import {RECEIVE_FAILED_VIEWER_GAMES, RECEIVE_VIEWER_GAMES, REQUEST_VIEWER_GAMES, UPDATE_VIEWER_GAME_PROPERTIES} from "../actions/games";

const games = (
    state = {
        data: [],
        runningOpenGames: [],
        cursor: null,
        lastValidCursor: null,
        loading: false
    }
    , action) => {
    switch (action.type) {
        case REQUEST_VIEWER_GAMES:
            return Object.assign({}, state, {
                loading: action.payload.reset && !action.payload.merge,
            });
        case RECEIVE_VIEWER_GAMES: {
            let games = state.data;
            if (action.payload.merge) {
                const oldGames = state.data ?? [];
                const newGames = action.payload.games.edges;
                const gamesMap = new Map();

                for (const game of newGames) {
                    gamesMap.set(game.node.id, game);
                }


                for (const game of oldGames) {
                    if (gamesMap.has(game.node.id)) {
                        continue;
                    }
                    gamesMap.set(game.node.id, game);
                }

                games = Array.from(gamesMap.values()).sort((a, b) => a.node.id - b.node.id);
            } else if (action.payload.reset) {
                games = [...action.payload.games.edges];
            } else {
                games = [...state.data, ...action.payload.games.edges];
            }

            return Object.assign({}, state, {
                data: games,
                runningOpenGames: action.payload.runningOpenGames?.edges ?? [],
                cursor: action.payload.games.pageInfo.endCursor,
                lastValidCursor: action.payload.reset ||
                     !action.payload.games.pageInfo.endCursor ||
                     action.payload.games.pageInfo.endCursor === state.cursor
                     ? null
                     : (state.cursor ?? state.lastValidCursor),
                loading: false
            });
        }
        case RECEIVE_FAILED_VIEWER_GAMES:
            return Object.assign({}, state, {
                loading: false
            });
        case UPDATE_VIEWER_GAME_PROPERTIES:
            if (!state.data) {
                return Object.assign({}, state);
            }
            return Object.assign({}, state, {
                data: state.data.map((g) => {
                    if (g.node.id != action.payload.gameId) {
                        return g;
                    }
                    const node = Object.assign({}, g.node, action.payload.properties);
                    return Object.assign({}, g, {node});
                }),
            });
    }

    return state;
};

export default games;
